import { QueryKey } from '@web/announcements/types/QueryKey';

export const getAnnouncementsQueryKey = () => [QueryKey.ANNOUNCEMENTS] as const;
export const getAnnouncementDetailsQueryKey = (id: number) => [QueryKey.ANNOUNCEMENTS, id] as const;
